import { render, staticRenderFns } from "./MSGroupRegList.vue?vue&type=template&id=b861f276"
import script from "./MSGroupRegList.vue?vue&type=script&lang=js"
export * from "./MSGroupRegList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports